import styled from 'styled-components'
import { rem } from 'polished'
import { Block } from '$views/components/Layout/Block'
import { Input } from '$views/components/Input'

export const StyledItem = styled.div`
  padding-top: ${p => rem(p.theme.sizes.base)};
  padding-bottom: ${p => rem(p.theme.sizes.base)};
  padding-left: ${p => rem(p.theme.sizes.base)};
  &:hover {
    background-color: ${p => p.theme.colors.xlightGrey};
  }
  border: solid 1px ${p => p.theme.colors.lightGrey};
  border-top: none;
  &:first-child {
    border-top: solid 1px ${p => p.theme.colors.lightGrey};
  }
`
export const StyledBlock = styled(Block)`
  position: absolute;
  background-color: ${p => p.theme.colors.white};
  z-index: 2;
  width: 100%;
`

export const StyledInput = styled(Input)`
  border-radius: ${rem(30)};
`



// WEBPACK FOOTER //
// ./src/views/components/Forms/LocationInput/Autocomplete/Autocomplete.styles.ts